import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { db } from "../db/state";
import { useKey } from "../lib/db/react";
import TimeZoneInput from "./timeZone/TimeZoneInput";

const messages = defineMessages({
  timeZone: {
    id: "settings.system.timeZone",
    defaultMessage: "Time Zone",
  },
});

const System: React.FC = () => {
  const intl = useIntl();
  const [timeZone, setTimeZone] = useKey(db, "timeZone");

  return (
    <div style={{ display: "grid", gridTemplateColumns: "max-content minmax(0, 1fr)", gap: "0.5rem", alignItems: "center" }}>
      <label style={{ margin: 0, whiteSpace: "nowrap" }}>
        {intl.formatMessage(messages.timeZone)}
      </label>
      <div style={{ minWidth: 0 }}>
        <TimeZoneInput timeZone={timeZone} onChange={setTimeZone} />
      </div>
    </div>
  );
};

export default System;
